import { defineMessages } from 'react-intl';

export const customPriceMessages = defineMessages({
  label: {
    id: 'customPrice.label',
    defaultMessage: 'Custom price',
  },
  hint: {
    id: 'customPrice.hint',
    defaultMessage: 'Optional. Leave empty to invoice at the list price.',
  },
  summary: {
    id: 'customPrice.summary',
    defaultMessage: 'List: {listPrice} → Invoice: {invoicePrice}',
  },
  integerValidation: {
    id: 'customPrice.integerValidation',
    defaultMessage: 'Enter a whole number from 0 to {max}',
  },
});
